import { customActivityButton } from './ActivityButton';

/** Button to view and perform a "Follow" action on an item. */
export default customActivityButton('Follow', 'Follow', 'You follow', 'Following');
